/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>hydUtils.service.ts</name>
///
/// <description>
/// A service that exposes static utilities to be shared  
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>24 Aug 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 24Aug16 YH  1.0.0000         First cut
/// 26Oct16 YH  1.0.0000         Add TimeLapsMilliseconds()
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///

export class hydUtilService {
    static TimeStamp() {
        // Create a date object with the current time
        var now = new Date();

        // Create an array with the current month, day and time
        var date = [ now.getMonth() + 1, now.getDate(), now.getFullYear() ];

        // Create an array with the current hour, minute and second
        var time = [ now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds() ];

        // Determine AM or PM suffix based on the hour
        var suffix = ( time[0] < 12 ) ? "AM" : "PM";

        // Convert hour from military time
        time[0] = ( time[0] < 12 ) ? time[0] : time[0] - 12;

        // If hour is 0, set it to 12
        time[0] = time[0] || 12;

        // If seconds and minutes are less than 10, add a zero
        // for ( var i = 1; i < 3; i++ ) {
        //     if ( time[i] < 10 ) {
        //     time[i] = "0" + time[i];
        //     }
        // }

        // Return the formatted string
        return date.join("/") + " " + time.join(":") + " " + suffix + " ";
    }

    static IsNumeric(val: any) {
        return !isNaN(val);

    }

    static ByteCount(s):any {
        return encodeURI(s).split(/%..|./).length - 1;
    }

    static CreateGUID():string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    static DisplayUptime(start:Date): string {

        let uptime: string = "NONE";

        if (start && start.getFullYear() > 1900) {
            var dateNow: any = new Date();
            var dateStart: any = start;

            var seconds = Math.floor((dateNow - dateStart) / 1000);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            var days = Math.floor(hours / 24);

            hours = hours - (days * 24);
            minutes = minutes - (days * 24 * 60) - (hours * 60);
            seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

            uptime = days + "d " + hours + "h " + minutes + "m " + seconds + "s"
        }
        return uptime;//123d 22h 33m 44s

    }

    static TimeLapsMilliseconds(start:Date, end:Date) : string {
        let nStart: any = start;
        let nEnd: any = end;
        return Math.ceil(nEnd - nStart).toString()+"ms";
    }

    static GetDeviceLanguages() {

        var languages = [

            {
                "label": "English (English)",
                "value": "en-US"
            },
            {
                "label": "Arabic (عربي)",
                "value": "ar-EG"
            },
            {
                "label": "Chinese Simplified (简体中文)",
                "value": "zh-CN"
            },
            {
                "label": "Chinese Traditional (繁體中文)",
                "value": "zh-TW"
            },
            {
                "label": "Czech (Čeština)",
                "value": "cs-CZ"
            },
            {
                "label": "Danish (Dansk)",
                "value": "da-DK"
            },
            {
                "label": "Dutch (Nederlands)",
                "value": "nl-NL"
            },
            {
                "label": "Finnish (Suomi)",
                "value": "fi-FI"
            },
            {
                "label": "French (Français)",
                "value": "fr-FR"
            },
            {
                "label": "German (Deutsch)",
                "value": "de-DE"
            },
            {
                "label": "Greek (Ελληνικά)",
                "value": "el-GR"
            },
            {
                "label": "Hebrew (עברית)",
                "value": "he-IL"
            },
            {
                "label": "Hungarian (Magyar)",
                "value": "hu-HU"
            },
            {
                "label": "Italian (Italiano)",
                "value": "it-IT"
            },
            {
                "label": "Japanese",
                "value": "ja-JP"
            },
            {
                "label": "Korean",
                "value": "ko-KR"
            },
            {
                "label": "Norwegian (Norsk)",
                "value": "nb-NO"
            },
            {
                "label": "Polish (Polski)",
                "value": "pl-PL"
            },
            {
                "label": "Portuguese (Português (Brasil))",
                "value": "pt-BR"
            },
            {
                "label": "Portuguese (Português (Portugal))",
                "value": "pt-PT"
            },
            {
                "label": "Romanian (Română)",
                "value": "ro-RO"
            },
            {
                "label": "Russian (Русский)",
                "value": "ru-RU"
            },
            {
                "label": "Slovak (slovenčina)",
                "value": "sk-SK"
            },
            {
                "label": "Spanish (Español)",
                "value": "es-ES"
            },
            {
                "label": "Swedish (Svenska)",
                "value": "sv-SE"
            },
            {
                "label": "Thai (ไทย)",
                "value": "th-TH"
            }
        ];

        return languages;
    }

    static GetVideoDisplayDrivers() {

        return [
            { label: "CEC Controlled Display", value: "CEC Controlled Display" },
            { label: "Crestron Connected Display", value: "Crestron Connected Display" },
            { label: "NEC MultiSync Series", value: "NEC MultiSync Series" },
            { label: "Panasonic TH Series", value: "Panasonic TH Series" },
            { label: "Samsung DM Series", value: "Samsung DM Series" },
            { label: "Samsung ME Series", value: "Samsung ME Series" },
            { label: "Sharp LC Series", value: "Sharp LC Series" },
            { label: "Sony FWD Series", value: "Sony FWD Series" }
        ];


    }

    static GetIPIDs() {

        let ids = [];
        let idValue: number;
        for (idValue = 3; idValue <= 253; idValue++) {
            ids.push({
                "label": "0x" + this.LeftPad(idValue.toString(16), 2).toUpperCase(),
                "value": idValue
            })
        }

        return ids;
    }

    static LeftPad(number, targetLength) {
        var output = number + '';
        while (output.length < targetLength) {
            output = '0' + output;
        }
        return output;
    }

    static GetTimeZones()  {

        var timezones = [
            {
                "value": "000",
                "label": "(UTC-12:00) International Date Line West"
            },
            {
                "value": "002",
                "label": "(UTC-11:00) Coordinated Universal Time -11"
            },
            {
                "value": "003",
                "label": "(UTC-10:00) Hawaii"
            },
            {
                "value": "112",
                "label": "(UTC-10:00) Tahiti"
            },
            {
                "value": "100",
                "label": "(UTC-09:30) Marquesas"
            },
            {
                "value": "004",
                "label": "(UTC-09:00) Alaska"
            },
            {
                "value": "101",
                "label": "(UTC-09:00) Gambier"
            },
            {
                "value": "005",
                "label": "(UTC-08:00) Pacific Time (US & Canada)"
            },
            {
                "value": "006",
                "label": "(UTC-08:00) Baja California"
            },
            {
                "value": "099",
                "label": "(UTC-08:00) Pitcairn Islands"
            },
            {
                "value": "007",
                "label": "(UTC-07:00) Mountain Time (US & Canada)"
            },
            {
                "value": "009",
                "label": "(UTC-07:00) Chihuahua, La Paz, Mazatlan"
            },
            {
                "value": "008",
                "label": "(UTC-07:00) Arizona"
            },
            {
                "value": "011",
                "label": "(UTC-06:00) Saskatchewan"
            },
            {
                "value": "012",
                "label": "(UTC-06:00) Central America"
            },
            {
                "value": "010",
                "label": "(UTC-06:00) Central Time (US & Canada)"
            },
            {
                "value": "013",
                "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey"
            },
            {
                "value": "102",
                "label": "(UTC-06:00) Easter Island"
            },
            {
                "value": "127",
                "label": "(UTC-06:00) Cancun, Quintana Roo"
            },
            {
                "value": "014",
                "label": "(UTC-05:00) Eastern Time (US & Canada)"
            },
            {
                "value": "016",
                "label": "(UTC-05:00) Bogota, Lima, Quito"
            },
            {
                "value": "015",
                "label": "(UTC-05:00) Indiana (East)"
            },
            {
                "value": "017",
                "label": "(UTC-04:30) Caracas"
            },
            {
                "value": "018",
                "label": "(UTC-04:00) Atlantic Time (Canada)"
            },
            {
                "value": "021",
                "label": "(UTC-04:00) Cuiaba"
            },
            {
                "value": "020",
                "label": "(UTC-04:00) Santiago"
            },
            {
                "value": "022",
                "label": "(UTC-04:00) Asuncion"
            },
            {
                "value": "019",
                "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
            },
            {
                "value": "023",
                "label": "(UTC-03:30) Newfoundland"
            },
            {
                "value": "027",
                "label": "(UTC-03:00) Buenos Aires"
            },
            {
                "value": "111",
                "label": "(UTC-03:00) Salvador"
            },
            {
                "value": "024",
                "label": "(UTC-03:00) Brasilia"
            },
            {
                "value": "026",
                "label": "(UTC-03:00) Greenland"
            },
            {
                "value": "028",
                "label": "(UTC-03:00) Montevideo"
            },
            {
                "value": "025",
                "label": "(UTC-03:00) Cayenne, Fortaleza"
            },
            {
                "value": "029",
                "label": "(UTC-02:00) Mid-Atlantic"
            },
            {
                "value": "032",
                "label": "(UTC-02:00) Coordinated Universal Time -02"
            },
            {
                "value": "031",
                "label": "(UTC-01:00) Azores"
            },
            {
                "value": "103",
                "label": "(UTC-01:00) Cape Verde Is."
            },
            {
                "value": "036",
                "label": "((UTC) Coordinated Universal Time)"
            },
            {
                "value": "033",
                "label": "((UTC) Dublin, Edinburgh, Lisbon, London)"
            },
            {
                "value": "034",
                "label": "((UTC) Monrovia, Reykjavik)"
            },
            {
                "value": "035",
                "label": "((UTC) Casablanca)"
            },
            {
                "value": "037",
                "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
            },
            {
                "value": "038",
                "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
            },
            {
                "value": "042",
                "label": "(UTC+01:00) Windhoek"
            },
            {
                "value": "039",
                "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris"
            },
            {
                "value": "041",
                "label": "(UTC+01:00) West Central Africa"
            },
            {
                "value": "040",
                "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
            },
            {
                "value": "113",
                "label": "(UTC+02:00) Tripoli"
            },
            {
                "value": "043",
                "label": "(UTC+02:00) E. Europe"
            },
            {
                "value": "044",
                "label": "(UTC+02:00) Cairo"
            },
            {
                "value": "045",
                "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
            },
            {
                "value": "046",
                "label": "(UTC+02:00) Athens, Bucharest"
            },
            {
                "value": "048",
                "label": "(UTC+02:00) Jerusalem"
            },
            {
                "value": "050",
                "label": "(UTC+02:00) Beirut"
            },
            {
                "value": "121",
                "label": "(UTC+03:00) Kaliningrad (RTZ 1)"
            },
            {
                "value": "047",
                "label": "(UTC+02:00) Harare, Pretoria"
            },
            {
                "value": "051",
                "label": "(UTC+02:00) Damascus"
            },
            {
                "value": "052",
                "label": "(UTC+02:00) Istanbul"
            },
            {
                "value": "049",
                "label": "(UTC+02:00) Amman"
            },
            {
                "value": "054",
                "label": "(UTC+03:00) Kuwait, Riyadh"
            },
            {
                "value": "056",
                "label": "(UTC+03:00) Baghdad"
            },
            {
                "value": "114",
                "label": "(UTC+03:00) Minsk"
            },
            {
                "value": "055",
                "label": "(UTC+03:00) Nairobi"
            },
            {
                "value": "058",
                "label": "(UTC+03:30) Tehran"
            },
            {
                "value": "117",
                "label": "(UTC+04:00) Moscow, St. Petersburg, Volgograd (RTZ 2)"
            },
            {
                "value": "060",
                "label": "(UTC+04:00) Abu Dhabi, Muscat"
            },
            {
                "value": "062",
                "label": "(UTC+04:00) Baku"
            },
            {
                "value": "061",
                "label": "(UTC+04:00) Yerevan"
            },
            {
                "value": "059",
                "label": "(UTC+04:00) Tbilisi"
            },
            {
                "value": "063",
                "label": "(UTC+04:00) Port Louis"
            },
            {
                "value": "124",
                "label": "(UTC+04:00) Izhevsk, Samara (RTZ 3)"
            },
            {
                "value": "064",
                "label": "(UTC+04:30) Kabul"
            },
            {
                "value": "067",
                "label": "(UTC+05:00) Islamabad, Karachi"
            },
            {
                "value": "122",
                "label": "(UTC+06:00) Ekaterinburg (RTZ 4)"
            },
            {
                "value": "066",
                "label": "(UTC+05:00) Tashkent"
            },
            {
                "value": "068",
                "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
            },
            {
                "value": "069",
                "label": "(UTC+05:30) Sri Jayawardenepura"
            },
            {
                "value": "070",
                "label": "(UTC+05:45) Kathmandu"
            },
            {
                "value": "073",
                "label": "(UTC+06:00) Dhaka"
            },
            {
                "value": "071",
                "label": "(UTC+06:00) Astana"
            },
            {
                "value": "120",
                "label": "(UTC+07:00) Novosibirsk (RTZ 5)"
            },
            {
                "value": "074",
                "label": "(UTC+06:30) Yangon (Rangoon)"
            },
            {
                "value": "118",
                "label": "(UTC+08:00) Krasnoyarsk (RTZ 6)"
            },
            {
                "value": "075",
                "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
            },
            {
                "value": "077",
                "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
            },
            {
                "value": "081",
                "label": "(UTC+08:00) Kuala Lumpur, Singapore"
            },
            {
                "value": "119",
                "label": "(UTC+09:00) Irkutsk (RTZ 7)"
            },
            {
                "value": "105",
                "label": "(UTC+08:00) Singapore"
            },
            {
                "value": "078",
                "label": "(UTC+08:00) Taipei"
            },
            {
                "value": "082",
                "label": "(UTC+08:00) Ulaanbaatar"
            },
            {
                "value": "079",
                "label": "(UTC+08:00) Perth"
            },
            {
                "value": "083",
                "label": "(UTC+09:00) Seoul"
            },
            {
                "value": "115",
                "label": "(UTC+10:00) Yakutsk (RTZ 8)"
            },
            {
                "value": "084",
                "label": "(UTC+09:00) Osaka, Sapporo, Tokyo"
            },
            {
                "value": "086",
                "label": "(UTC+09:30) Darwin"
            },
            {
                "value": "087",
                "label": "(UTC+09:30) Adelaide"
            },
            {
                "value": "088",
                "label": "(UTC+10:00) Canberra, Melbourne, Sydney"
            },
            {
                "value": "089",
                "label": "(UTC+10:00) Brisbane"
            },
            {
                "value": "116",
                "label": "(UTC+11:00) Vladivostok, Magadan (RTZ 9)"
            },
            {
                "value": "090",
                "label": "(UTC+10:00) Hobart"
            },
            {
                "value": "092",
                "label": "(UTC+10:00) Guam, Port Moresby"
            },
            {
                "value": "106",
                "label": "(UTC+10:30) Lord Howe Island"
            },
            {
                "value": "093",
                "label": "(UTC+11:00) Solomon Is., New Caledonia"
            },
            {
                "value": "107",
                "label": "(UTC+11:30) Norfolk Island"
            },
            {
                "value": "095",
                "label": "(UTC+12:00) Fiji"
            },
            {
                "value": "094",
                "label": "(UTC+12:00) Magadan"
            },
            {
                "value": "096",
                "label": "(UTC+12:00) Auckland, Wellington"
            },
            {
                "value": "126",
                "label": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky (RTZ 11)"
            },
            {
                "value": "097",
                "label": "(UTC+12:00) Coordinated Universal Time +12"
            },
            {
                "value": "109",
                "label": "(UTC+12:45) Chatham Island"
            },
            {
                "value": "001",
                "label": "(UTC+13:00) Samoa"
            },
            {
                "value": "098",
                "label": "(UTC+13:00) Nuku'alofa"
            },
            {
                "value": "123",
                "label": "(UTC+14:00) Kiritimati Island"
            }
        ];

        return timezones;
    }
    static GetTransportTypes() {

        return [
            { label: "UDP", value: "UDP" },
            { label: "TCP", value: "TCP" },
            { label: "TLS", value: "TLS" }

        ];


    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/utils/hydUtils.service.ts